import React from "react";
import "../CSS/CookiePolicy.css";

const CookiePolicy = () => {
  return (
    <div className="cookie-policy-container">
      <header className="cookie-policy-header">
        <h1 className="cookie-policy-title">Cookie Policy</h1>
        <p className="cookie-policy-subtitle">How we use cookies and similar technologies</p>
      </header>
      
      <div className="cookie-policy-content">
  
  <p>Last updated: September 10, 2025</p>

  <p>This Cookie Policy explains how we use cookies and similar technologies when you visit or use our websites, applications, and related services (collectively, the “Services”). This policy is intended to be generic and may be adapted based on your specific implementation.</p>

  <h4>1. What Are Cookies?</h4>
  <p>Cookies are small text files placed on your device that enable features and functionality. They can be “session” cookies (deleted when you close your browser) or “persistent” cookies (remain until they expire or are deleted).</p>

  <h4>2. Types of Cookies We Use</h4>
  <ul>
    <li><strong>Strictly necessary:</strong> Required for the Services to function (e.g., authentication, security).</li>
    <li><strong>Performance/analytics:</strong> Help us understand how the Services are used and improve performance.</li>
    <li><strong>Functional:</strong> Remember choices you make to provide enhanced features and personalization.</li>
    <li><strong>Advertising/targeting:</strong> Used to deliver relevant ads and measure campaign effectiveness.</li>
  </ul>

  <h4>3. How We Use Cookies</h4>
  <p>We use cookies to operate and secure the Services, remember preferences, analyze usage, and personalize content. We may combine cookie information with other data we collect.</p>

  <h4>4. Third-Party Cookies</h4>
  <p>Service providers and partners may set cookies through the Services for analytics, advertising, and other purposes, subject to their own policies.</p>

  <h4>5. Managing Cookies</h4>
  <p>You can control cookies through your browser or device settings. If you disable certain cookies, some features of the Services may not function properly.</p>
  <p>For general information about cookies and how to manage them, visit:
  <ul>
    <li><a href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer">aboutcookies.org</a></li>
    <li><a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer">allaboutcookies.org</a></li>
  </ul>
  </p>

  <h4>6. Do Not Track</h4>
  <p>Some browsers offer a “Do Not Track” (DNT) feature. We do not currently respond to DNT signals. You can use other tools (e.g., cookie controls) to manage tracking.</p>

  <h4>7. Changes to This Policy</h4>
  <p>We may update this Cookie Policy from time to time. If we make material changes, we will update the “Last updated” date and, where appropriate, provide additional notice.</p>

  <h4>8. Contact Us</h4>
  <p>If you have questions about our use of cookies, contact us at: <strong>support@example.com</strong></p>
      </div>
    </div>
  );
};

export default CookiePolicy;

